module.exports = __webpack_public_path__ + "img/byjuno.b7e11177.svg";